import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {
    BBDisableChildren, bbDoesCustomerHaveAccessToModule,
    bbErrorSection, bbGetModulePropertyFromIdOrName,
    bbIsCampaignActive,
    bbIsVectorPotentiallyBreaching, BBModuleIcon, isCurrentUserMemberOf
} from "../../../../../util/bbHelpers";
import {useDispatch, useSelector} from "react-redux";
import VectorCard from "../../../../../components/customBreachBits/vectors/VectorCard";
import {
    fetchCampaignsAction,
    fetchCustomers,
    fetchTargets,
    fetchVectorsAction,
} from "../../../../../actions";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import PhishingVectorCard from "../../../../../components/customBreachBits/vectors/VectorCard/PhishingVectorCard";
import TileCountVectorsCampaignsViableForCustomer
    from "../../../../../components/customBreachBits/metrics/TileCountVectorsCampaignsViableForCustomer";
import TileCountVectorsViableForCustomer
    from "../../../../../components/customBreachBits/metrics/TileCountVectorsPotentiallyBreaching";
import TileCountCampaignsViableForCustomer
    from "../../../../../components/customBreachBits/metrics/TileCountCampaignsViableForCustomer";
import TileCountPhishingAttacksForCustomer
    from "../../../../../components/customBreachBits/metrics/TileCountPhishingAttacksForCustomer";
import TileCountVectorsNotViable from "../../../../../components/customBreachBits/metrics/TilePercentVectorQuality";
import CircularProgress from "../../../../../components/prefabricated/CircularProgress";
import IconShowingIfCustomerHasAccessToModule
    from "../../../../../components/customBreachBits/info/IconShowingIfCustomerHasAccessToModule";
import { HashLink as Link } from 'react-router-hash-link';


const VectorsSection = (props, {children}) => {

    // const {customers, customerInView} = useSelector(({customer}) => customer);
    // console.log("Customers in BreachBoardContent: ", customers);
    // const customer = getInViewCustomerObject(customerInView, customers);

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers, customerInView, loadingCustomers, loadingVectors, loadingTargets, loadingVectorsError, loadingCampaigns, loadingCampaignsError} = useSelector(({customer}) => customer);
    const {authUser} = useSelector(({auth}) => auth);
    const dispatch = useDispatch();
    //select the customer from the store if it exists, based on the props customerId
    const customer = customers ? customerId ? customers[customerId] : customerInView ? customers[customerInView] : null : null;
    //from the customer, pull the target data if it exists
    const vectors = customer ? customer.vectors ? customer.vectors : null : null;
    const campaigns = customer ? customer.campaigns ? customer.campaigns : null : null;
    const [firstVector, setFirstVector] = useState(vectors ? vectors[Object.keys(vectors)[0]] : null);
    const targets = customer ? customer.targets ? customer.targets : null : null;
    const [target, setTarget] = useState(targets ? firstVector ? targets[firstVector.TargetId] ? targets[firstVector.TargetId] : null : null : null);


    /*  jfd*******************************
    *   Scrolling
        ********************************** */

    //used to allow scrolling from clicking data tiles.

    // let urlHashScrollTo = window.location.hash;
    // const readyToScroll = vectors && campaigns && !loadingVectors && !loadingCampaigns;
    //
    // if (urlHashScrollTo && readyToScroll) {
    //     const elementToScrollTo = document.getElementById(urlHashScrollTo.substring(1));
    //
    //     bbDelayedExecuteScroll(elementToScrollTo);
    //
    //     window.location.hash = "";
    // }

    /*  jfd*******************************
     *   END SCROLLING
         ********************************** */



    const vectorsWithTargetsPresent = (vectors, targets, customerId) => {
        if(vectors && Object.keys(vectors).length && targets && Object.keys(targets).length) {
            // console.log("looking for matching vectors and targets vectors: ", vectors, "targets: ", targets);
            const list = []
            for (const vectorId in vectors) {
                //look for the corresponding target
                // console.log("Inside the vectors loop...");
                const foundTarget = targets[vectors[vectorId].TargetId] ? targets[vectors[vectorId].TargetId] : false;
                if (foundTarget) {
                    // console.log("Found a match. Vector: ", vectors[vectorId], "found target: ", foundTarget);
                    list.push({
                        "vector": vectors[vectorId],
                        "target": foundTarget
                    })
                } else {
                    //target wasn't found in local store, so initiate a dispatch
                    // console.log("Dispatching for target: ", vectors[vectorId].TargetId)

                    //don't fetch this because now we are prefetchign all targets.
                    // dispatch(fetchTargetAction({
                    //     customerId: customerId,
                    //     targetId: vectors[vectorId].TargetId
                    // }))
                    // add a null target, so can show that it's loading
                    list.push({
                        "vector": vectors[vectorId],
                        "target": null
                    })
                }
            }
            // console.log("List made: ", list);
            return list;
        } else {
            // console.log("vectors and targets was false")
            return [];
        }
    }

    const allVectorsWithTargetsPresent = vectorsWithTargetsPresent(vectors, targets, customerId);
    const vectorsThatCouldCauseBreach = allVectorsWithTargetsPresent.filter((vt) => bbIsVectorPotentiallyBreaching(vt.vector));
    const vectorsUnlikelyToCauseBreach = allVectorsWithTargetsPresent.filter((vt) =>  !bbIsVectorPotentiallyBreaching(vt.vector));
    const campaignsActive =  campaigns ? Object.keys(campaigns).map((k) => campaigns[k]).filter(campaign => bbIsCampaignActive(campaign)) : [];
    // console.log("campaignsActive is", campaignsActive, "from ", campaigns);
    const campaignsInactive = campaigns ? Object.keys(campaigns).map((k) => campaigns[k]).filter(campaign => !bbIsCampaignActive(campaign)) : [];
    // console.log("campaignsInactive is", campaignsInactive, "from ", campaigns);

    // console.log("vectors with targets present calling: ", vectorsWithTargetsPresent(vectors, targets, customerId));

    useEffect(() => {
        if (!customers && !loadingCustomers) {
            // console.log("Customers is empty, fetching.")
            dispatch(fetchCustomers());
        } else if (customer && vectors === null && !loadingVectors) {
            // console.log("vectors is empty, fetching vectors for customerId = ", customer.CustomerId);
            dispatch(fetchVectorsAction({
                customerId: customer.CustomerId
            }));
        } else if (customer && targets === null && !loadingTargets) {
            dispatch(fetchTargets({
                customerId: customer.CustomerId
            }));
        }

        if (!customers && !loadingCustomers) {
            // console.log("Customers is empty, fetching.")
            // dispatch(fetchCustomers());
        } else if (customer && campaigns === null && !loadingCampaigns) {
            console.log("campaigns is empty, fetching vectors for customerId = ", customer.CustomerId);
            dispatch(fetchCampaignsAction({
                customerId: customer.CustomerId
            }));
        }

        setFirstVector(vectors ? vectors[Object.keys(vectors)[0]] : null);
        // setTarget(targets ? firstVector ? targets[firstVector.TargetId] ? targets[firstVector.TargetId] : null : null : null);

        // console.log("vectors is", vectors);
        // console.log("firstVector is", firstVector);
        // console.log("target is", target);
    }, [customers, customer, firstVector, targets, campaigns, dispatch, loadingVectors, loadingCampaigns, loadingTargets, loadingCustomers, vectors]);

    /**************************/
    /*End Setup State and Dispatch*/
    /**************************/


    return (
        <div className={`bb-tab-section`}>
            <div className={"row"}>
                <div className={"col-6"}>
                    <h3>Vectors <Tooltip title={"Vectors exist when an attacker has a capability that can breach a target."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                    <p><strong>Vectors</strong> are formed with targets from the <Tooltip title={"Humans and Systems expose vulnerable & interactive elements to attackers."}><strong>Attack Surface</strong></Tooltip> that can be attacked; they are the prime source of risk.  CIRT pairs attack capabilities with the opportunities created by targets to conduct attacks.  Vectors either cause a breach, are blocked by your defenses, or fail for other reasons. Viable, impactful Vectors dramatically increase your cybersecurity risk, but successful defense significantly reduce your risk.</p>

                </div>
                <div className={"col-3 align-self-center text-center"}>
                    {/*<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("perimeter", "id")} isActive={bbDoesUserHaveAccessToModule(authUser, "perimeter")} iconSize={"80px"}/>*/}
                    <IconShowingIfCustomerHasAccessToModule module={"perimeter"}/>
                </div>
                <div className={"col-3 align-self-center text-center"}>
                    {/*<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("perimeter", "id")} isActive={bbDoesUserHaveAccessToModule(authUser, "perimeter")} iconSize={"80px"}/>*/}
                    <IconShowingIfCustomerHasAccessToModule module={"social"}/>
                </div>
            </div>

            <div className="row">

                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6 tourStepDangerousVectors">
                    <TileCountVectorsCampaignsViableForCustomer/>
                </div>
                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6 tourStepVectorQuality">
                    <TileCountVectorsNotViable/>
                </div>
                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-4 tourStepPerimeterVectors">
                    <Link to={{hash:"PerimeterVectorsSection"}}>
                        <TileCountVectorsViableForCustomer/>
                    </Link>

                </div>
                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-4 tourStepSocialVectors">
                    <Link to={{hash:"SocialVectorsSection"}}>
                        <TileCountCampaignsViableForCustomer/>
                    </Link>
                </div>
                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-4 tourStepPhishingAttacks">
                    <Link to={{hash:"SocialVectorsSection"}}>
                        <TileCountPhishingAttacksForCustomer/>
                    </Link>

                </div>
            </div>
            <hr/>
            <div className="row ">
                <div  className={`active-vectors col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 animated fadeIn animation-duration-7 tourStepIndividualVectors`}>
                    <div id={"PerimeterVectorsSection"}>
                        {(loadingVectors && !loadingVectorsError) && (
                            <>
                                <div style={{marginTop: "-8px", marginRight: "6px", float: "left"}}>
                                    <BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("perimeter", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "perimeter")} iconSize={"40px"}/>
                                </div>
                                <h3>Perimeter Vectors That Could Potentially Cause a Breach <Tooltip title={"Perimeter vectors directly attack your outer defenses."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                                <CircularProgress/>
                            </>
                        )}
                        {(!loadingVectors && !loadingVectorsError && (!firstVector || (vectorsThatCouldCauseBreach.length < 1 && vectorsUnlikelyToCauseBreach.length > 0))) && (
                            <>
                                <div style={{marginTop: "-8px", marginRight: "6px", float: "left"}}>
                                    <BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("perimeter", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "perimeter")} iconSize={"40px"}/>
                                </div>

                                <h3>Perimeter Vectors That Could Potentially Cause a Breach <Tooltip title={"Perimeter vectors directly attack your outer defenses."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                                <em><h4>There are no perimeter vectors likely to cause a breach.  There may be others designated as "unlikely."</h4></em>
                            </>
                        )

                        }
                        {(!loadingVectors && firstVector && vectorsThatCouldCauseBreach.length > 0) && (
                            <>
                                <div style={{marginTop: "-8px", marginRight: "6px", float: "left"}}>
                                    <BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("perimeter", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "perimeter")} iconSize={"40px"}/>
                                </div>
                                <h3>Perimeter Vectors That Could Potentially Cause a Breach <Tooltip title={"Perimeter vectors directly attack your outer defenses."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>


                                {vectorsThatCouldCauseBreach.map((vt, index) => {
                                    if(index < 3 || bbDoesCustomerHaveAccessToModule(customer, "perimeter")) {
                                        return <div key={`${vt.vector.Id}_parentDiv`}
                                                    className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 animated fadeIn animation-duration-7">
                                            <VectorCard vector={vt.vector} target={vt.target} customerId={customer.CustomerId} key={`${vt.vector.Id}`}/><br/></div>
                                    } else {
                                        return <BBDisableChildren
                                            isDisabled={false}
                                            moduleRequired = {"perimeter"}
                                            blurLevel={(isCurrentUserMemberOf(authUser, "admin")|| isCurrentUserMemberOf(authUser, "staff")) ? 0 : 5}
                                            >


                                        <div key={`${vt.vector.Id}_parentDiv`}
                                                    className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 animated fadeIn animation-duration-7">
                                            <VectorCard vector={vt.vector} target={vt.target} customerId={customer.CustomerId} key={`${vt.vector.Id}`}/><br/></div>
                                        </BBDisableChildren>
                                    }

                                })
                                }
                            </>
                        )
                        }
                        {loadingVectorsError &&
                        bbErrorSection()
                        }
                    </div>


                    <hr/>
                    <div id={"SocialVectorsSection"}>
                        {(loadingCampaigns && !loadingCampaignsError) && (
                            <>
                                <div style={{marginTop: "-8px", marginRight: "6px", float: "left"}}>
                                    <BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("social", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "social")} iconSize={"40px"}/>
                                </div>
                                <h3>Social Engineering Vectors <Tooltip title={"Social engineering vectors attempt to trick humans identified as being associated with your company."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                                <CircularProgress/>
                            </>
                        )}
                        {(!loadingCampaigns && !loadingCampaignsError && (campaignsActive.length < 1)) && (
                            <>
                                <div style={{marginTop: "-8px", marginRight: "6px", float: "left"}}>
                                    <BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("social", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "social")} iconSize={"40px"}/>
                                </div>
                                <h3>Social Engineering Vectors <Tooltip title={"Social engineering vectors attempt to trick humans identified as being associated with your company."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                                <em><h4>There are no active social engineering vectors.</h4></em>
                            </>
                        )

                        }
                        {(!loadingCampaigns && campaignsActive.length > 0) && (
                            <>

                                <div style={{marginTop: "-8px", marginRight: "6px", float: "left"}}>
                                    <BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("social", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "social")} iconSize={"40px"}/>
                                </div>
                                <h3>Social Engineering Vectors <Tooltip title={"Social engineering vectors attempt to trick humans identified as being associated with your company."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>

                                {campaignsActive.map((campaign, index) =>{
                                    if(index < 1 || bbDoesCustomerHaveAccessToModule(customer, "social")) {
                                        return <div key={`${campaign.CampaignId}_parentDiv`}
                                                    className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 animated fadeIn animation-duration-7">
                                            <PhishingVectorCard campaign={campaign} customerId={customer.CustomerId}
                                                                key={`${campaign.CampaignId}`}/><br/></div>
                                    } else {
                                        return <BBDisableChildren
                                            isDisabled={false}
                                            moduleRequired = {"social"}
                                            blurLevel={(isCurrentUserMemberOf(authUser, "admin")|| isCurrentUserMemberOf(authUser, "staff")) ? 0 : 5}
                                        >
                                            <div key={`${campaign.CampaignId}_parentDiv`}
                                                 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 animated fadeIn animation-duration-7">
                                                <PhishingVectorCard campaign={campaign} customerId={customer.CustomerId}
                                                                    key={`${campaign.CampaignId}`}/><br/></div>
                                        </BBDisableChildren>
                                    }

                                })}


                            </>
                        )
                        }
                        {loadingCampaignsError &&
                        bbErrorSection()
                        }
                    </div>

                    {/*{(!loadingVectors && firstVector && vectorsWithInActiveTarget.length > 0) && (*/}
                    {/*     <>*/}
                    {/*         <h3>Inactive Vectors <Tooltip title={"Inactive vectors are not being pursued because the target has moved or previous pursuits concluded that the capability would not achieve a breach."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>*/}
                    {/*        {vectorsWithInActiveTarget.map((vt) => <div key={`${vt.vector.Id}_parentDiv`} className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 animated fadeIn animation-duration-7"><VectorCard vector={vt.vector} target={vt.target} customerId={customer.CustomerId} key={`${vt.vector.Id}`}/><br/></div>)}*/}
                    {/*     </>*/}
                    {/*)*/}

                    {/*}*/}

                    {(!loadingCampaigns && !loadingVectors && (campaignsInactive.length > 0 || vectorsUnlikelyToCauseBreach.length > 0)) && (
                        <>
                            <hr/>
                            <h3>Vectors Unlikely to Cause a Breach <Tooltip title={"While it is still possible for an attacker to use these Vectors to cause a breach, it is relatively unlikely."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                            {vectorsUnlikelyToCauseBreach.map((vt) => <div key={`${vt.vector.Id}_parentDiv`} className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 animated fadeIn animation-duration-7"><VectorCard vector={vt.vector} target={vt.target} customerId={customer.CustomerId} key={`${vt.vector.Id}`}/><br/></div>)}
                            {campaignsInactive.map(campaign => <div key={`${campaign.CampaignId}_parentDiv`} className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 animated fadeIn animation-duration-7"><PhishingVectorCard campaign={campaign} customerId={customer.CustomerId} key={`${campaign.CampaignId}`}/><br/></div>)}
                        </>
                    )
                    }
                </div>
            </div>
            <br/>

        </div>
    )


};

VectorsSection.propTypes = {
    customerId: PropTypes.string,
};

export default VectorsSection;

